// extracted by mini-css-extract-plugin
export default {"task-list-frag":"style_task-list-frag__8OsAF","rich-text-block":"style_rich-text-block__pgR1J"};